import React, { useEffect, useState } from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { links } from 'utils/featureToggles'

import TransactionDetailsAdjustmentWalletAndPaymentAgentPage from '../TransactionDetailsAdjustmentWalletAndPaymentAgent/TransactionDetailsAdjustmentWalletAndPaymentAgentPage'

interface Props {
  data: TransactionDto
  forceRefresh(): void
}

const TransactionDetailsIBCashbackPage: React.FC<Props> = (props) => {
  const [crumbs, setCrumbs] = useState([
    { title: 'Transactions - IB Cashback', link: links.transactionIBCashBacks.url },
  ])

  useEffect(() => {
    const [crumb1, crumb2] = [
      ...crumbs,
      {
        title: props.data.referenceId,
        link: '/transactions/' + props.data.id,
      },
    ]
    setCrumbs([crumb1, crumb2])
  }, [props.data]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <Breadcrumbs crumbs={crumbs} />
      <TransactionDetailsAdjustmentWalletAndPaymentAgentPage {...props} />
    </React.Fragment>
  )
}

export default TransactionDetailsIBCashbackPage
